import { render, staticRenderFns } from "./SolutionsB.vue?vue&type=template&id=070af845"
import script from "./SolutionsB.vue?vue&type=script&lang=js"
export * from "./SolutionsB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports